//Custom components
import { transformProjectTypeChartDataSets } from '@/utils';
import Card from '../../../UI/Card/index.tsx';
import PieChart from '../../../UI/Charts/PieChart';

const standardSocialDesignation = ['Minority Owned', 'Woman Owned', 'Disadvantaged Business Enterprise', 'Veteran Owned', 'Local Business'];

export interface ISocialDesignationWidgetData {
  socialDesignation: string;
  _count: { socialDesignation: number };
}

export interface ISocialDesignationWidgetProps {
  data: ISocialDesignationWidgetData[];
}

export default function SocialDesignationWidget(props: ISocialDesignationWidgetProps) {
  const { data } = props;

  const transformSocialDesignationData = data?.reduce((acc: ISocialDesignationWidgetData[], current: ISocialDesignationWidgetData) => {
    if (!standardSocialDesignation.includes(current.socialDesignation)) {
      let existingOthersCount = acc.find((sd) => sd.socialDesignation === 'Others')?._count.socialDesignation || 0;
      existingOthersCount += current._count.socialDesignation;

      const existingOthersIndex = acc.findIndex((sd) => sd.socialDesignation === 'Others');

      if (existingOthersIndex > -1) {
        acc[existingOthersIndex] = {
          socialDesignation: 'Others',
          _count: { socialDesignation: existingOthersCount },
        };
        return acc;
      } else {
        return [
          ...acc,
          {
            socialDesignation: 'Others',
            _count: { ...current._count },
          },
        ];
      }
    }
    return [...acc, { ...current }];
  }, []);

  const socialDesignationTypeLabels = transformSocialDesignationData?.map((data: ISocialDesignationWidgetData) => data?.socialDesignation);

  const projectsBySocialDesignationType = transformSocialDesignationData?.map((data: ISocialDesignationWidgetData) => {
    return {
      type: data?.socialDesignation,
      count: data?._count?.socialDesignation,
    };
  });

  const totalSocialDesignationType = data?.reduce((acc: number, data: ISocialDesignationWidgetData) => {
    return acc + data?._count?.socialDesignation;
  }, 0);

  return (
    <Card title='Social Designation'>
      <div className='relative p-5 h-80'>
        <div className='absolute px-5 text-center'>
          <h3 className='text-gray-500 font-bold'>Total Designations</h3>
          <h1 className='m-0'>{totalSocialDesignationType}</h1>
        </div>
        <div className='md:w-7/8 xl:w-full h-full'>
          <PieChart
            labels={socialDesignationTypeLabels}
            datasets={transformProjectTypeChartDataSets(projectsBySocialDesignationType)}
            chartTitle='Total Project Types'
          />
        </div>
      </div>
    </Card>
  );
}
